var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRunningMan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.67,346.25c31.56,18.34,74,21.3,109.32,12.38,17.74-4.49,30.92-13.86,46.21-22.78,21.42-12.51,37.44-11.19,61.43-12.61,69.83-4.12,89.8-71.3,82.29-117.83-9.12-56.58-60.8-101.19-122.64-105.92-41.63-3.18-80.09,2.63-112.68,20.42-25.44,13.89-28.33,35.8-32.48,61.18-3.17,19.37-5.19,41-17.11,57.76-10.91,15.33-26.76,6.48-40.64,17C67,282.53,102.09,330.8,128.67,346.25Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.67,346.25c31.56,18.34,74,21.3,109.32,12.38,17.74-4.49,30.92-13.86,46.21-22.78,21.42-12.51,37.44-11.19,61.43-12.61,69.83-4.12,89.8-71.3,82.29-117.83-9.12-56.58-60.8-101.19-122.64-105.92-41.63-3.18-80.09,2.63-112.68,20.42-25.44,13.89-28.33,35.8-32.48,61.18-3.17,19.37-5.19,41-17.11,57.76-10.91,15.33-26.76,6.48-40.64,17C67,282.53,102.09,330.8,128.67,346.25Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-20"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-20",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speedometer--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.53,113.94l-.63-.78a166.31,166.31,0,0,1,13.7-10l.55.84A164.35,164.35,0,0,0,166.53,113.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.15,120.25l-.68-.74c1.34-1.21,2.72-2.42,4.09-3.59l.65.77C161.84,117.85,160.48,119.05,159.15,120.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.41,
    cy: 181.2,
    rx: 115.24,
    ry: 81.19,
    transform: "translate(-65.78 187.53) rotate(-41.22)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.41,
    cy: 181.2,
    rx: 99.97,
    ry: 70.43,
    transform: "translate(-65.78 187.53) rotate(-41.22)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.15,103.89c-43.29,3.51-87.67,41-99.13,83.66l156.77-12.69C306.25,132.16,280.44,100.39,237.15,103.89Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,187.55l78.39-6.35L175.65,131C157.71,146.16,143.75,166.2,138,187.55Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.15,103.89c-21.64,1.76-43.56,12-61.5,27.13l40.76,50.18,20.74-77.31Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.15,103.89,216.41,181.2l70.09-59.15C276.07,109.21,258.8,102.14,237.15,103.89Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.41,
    cy: 181.2,
    rx: 40.79,
    ry: 28.73,
    transform: "translate(-65.78 187.53) rotate(-41.22)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.41,
    cy: 181.2,
    rx: 23.8,
    ry: 16.77,
    transform: "translate(-65.78 187.53) rotate(-41.22)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.08,139.85a236.29,236.29,0,0,0-52.63,27.9l7.37,13.2A257.66,257.66,0,0,0,275.08,139.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,217.06a1.51,1.51,0,0,1-1.55-1.84,2.73,2.73,0,0,1,2.36-2.16L234,206.23a1.51,1.51,0,0,1,1.7,1.83,2.7,2.7,0,0,1-2.35,2.15l-86.12,6.84Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.55,225.26a1.5,1.5,0,0,1-1.55-1.84,2.7,2.7,0,0,1,2.36-2.15l28-2.23a1.51,1.51,0,0,1,1.71,1.83,2.72,2.72,0,0,1-2.36,2.16l-28,2.22Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.15,261.08a1.51,1.51,0,0,1-1.55-1.84A2.72,2.72,0,0,1,80,257.09l28-2.23a1.52,1.52,0,0,1,1.71,1.83,2.72,2.72,0,0,1-2.35,2.16l-28,2.22Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.09,244.71a1.5,1.5,0,0,1-1.54-1.84,2.71,2.71,0,0,1,2.35-2.15l84-6.67a1.52,1.52,0,0,1,1.71,1.83,2.73,2.73,0,0,1-2.36,2.16l-84,6.66Z",
    style: {
      fill: "#E34B4B"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "284.39 334.51 287.95 341.7 305.56 335.37 302 328.18 284.39 334.51",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.77 393.64 204.12 399.63 217.72 384.18 211.13 379.6 198.77 393.64",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.34,399l-3.64-9.09a.67.67,0,0,0-.75-.41L193.84,391a1.22,1.22,0,0,0-.86,1.67c1.22,2.9,2.24,5,3.71,8.64.91,2.27,3.41,9.2,4.67,12.33s4.45,2.17,4.22.76c-1.07-6.29-1.1-11.38-.21-13.95A2,2,0,0,0,205.34,399Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.76,341.24l-3.89-7.86a.71.71,0,0,0-.79-.37l-7.1,1.75a1.16,1.16,0,0,0-.77,1.67c1.45,2.81,3.64,6.82,5.41,10.38,2.06,4.17,2.34,4.3,4.76,9.18,1.46,2.95,4.85,2.3,4.51.93-1.56-6.24-2.43-7.32-1.83-13.67A3.73,3.73,0,0,0,288.76,341.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,205.24c-.37,2.6-.77,5.4-1.08,8.11s-.62,5.47-.85,8.2a116.24,116.24,0,0,0-.48,16.06c0,.65.06,1.3.14,1.91l.18,1.78a2.51,2.51,0,0,0,1.71,2.39,10.94,10.94,0,0,0,2.85.86,34,34,0,0,0,7.44.28c1.31-.09,2.65-.19,4-.35s2.72-.37,4-.56l1.94,5.71a44,44,0,0,1-4.24,1.73,43,43,0,0,1-4.35,1.36,39.66,39.66,0,0,1-4.59.93,28.36,28.36,0,0,1-4.94.32,20.11,20.11,0,0,1-5.48-.83,13.71,13.71,0,0,1-5.74-3.45,13.05,13.05,0,0,1-3.32-6.27c-.07-.31-.1-.48-.13-.68l-.1-.58-.21-1.18c-.15-.78-.25-1.55-.34-2.32a103.34,103.34,0,0,1-.38-18c.19-2.94.4-5.86.76-8.76s.71-5.75,1.27-8.76Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.19,198c-5.26,5.59-3.14,19.7-3.14,19.7L356.83,220s3.43-8,2.14-16.25C357.39,193.73,350.94,191.85,345.19,198Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,204.19c-2.44-3.14-5-4.26-6.36-4-3.27,6.41-1.61,17.47-1.61,17.47l10.47,1.7C353.7,216.11,353.85,209.1,350,204.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.94,244.79l8.57-5.62,1.9,8.7s-5.33,5.4-9.77,1.59Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.78 237.29 388.77 244.81 384.41 247.87 382.5 239.17 387.78 237.29",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.55 335.38 296.48 338.64 292.92 331.44 301.99 328.18 305.55 335.38",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.13 379.6 217.72 384.18 211.34 391.42 204.75 386.83 211.13 379.6",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.74,178.71c-6.08,31.11-22.27,59.18-24.53,65.38,5.8,2.43,27.69,11.55,39.62,16.52,22.25-33.11,25.66-57.07,26.17-62.87a2.38,2.38,0,0,0-1-2.15c-.95-.69-2.47-1.77-4.32-3-1-.64-2.07-1.31-3.22-2-.63-.37-1.28-.73-1.94-1.08a159,159,0,0,0-16.85-7c-1.08-.39-2.19-.77-3.28-1.11s-2-.61-2.95-.87C318.18,179.39,314.74,178.71,314.74,178.71Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.56,223.07l2.19.56a12.53,12.53,0,0,1-5.13,3,12.4,12.4,0,0,1-6.76.1,10,10,0,0,1-5.16-2.82,6.52,6.52,0,0,1-1.62-4.9,14.78,14.78,0,0,1,1.74-6,20.92,20.92,0,0,1,4.62-6,15,15,0,0,1,6-3.44,11.89,11.89,0,0,1,6.18-.1,7.43,7.43,0,0,1,4,2.34A6.06,6.06,0,0,1,346,210a11.5,11.5,0,0,1-1.39,5,14.46,14.46,0,0,1-4.47,5.16c-2.43,1.75-4.7,2.35-6.8,1.82a1.66,1.66,0,0,1-1.11-.67,1.54,1.54,0,0,1,0-1.17,4.79,4.79,0,0,1-3.5.67,2.71,2.71,0,0,1-2.12-2.1,5.67,5.67,0,0,1,.77-3.95,14.37,14.37,0,0,1,4-4.83q3.1-2.43,5.67-1.79a2.23,2.23,0,0,1,1.86,2.32l.94-1.27,2.71.69-6,8.25a10,10,0,0,0-.69,1,.88.88,0,0,0-.12.49.28.28,0,0,0,.21.22,2.9,2.9,0,0,0,1.63-.38,9.86,9.86,0,0,0,3-2,11.36,11.36,0,0,0,2.3-3,7,7,0,0,0,.73-5.43q-.81-2.46-4.08-3.28a9.62,9.62,0,0,0-5.4.14,12.36,12.36,0,0,0-4.85,3,18.56,18.56,0,0,0-3.58,4.79,10.6,10.6,0,0,0-1.29,4.91,5.21,5.21,0,0,0,1.5,3.82,8.65,8.65,0,0,0,4,2.1,11.37,11.37,0,0,0,4.64.26A9.84,9.84,0,0,0,338.56,223.07ZM330,215.32a4.13,4.13,0,0,0-.63,2.38,1.21,1.21,0,0,0,.94,1.06,2.32,2.32,0,0,0,1.27-.06,4.55,4.55,0,0,0,1.16-.57,9.89,9.89,0,0,0,2.05-1.91,13.44,13.44,0,0,0,1.75-2.53,3.65,3.65,0,0,0,.53-2.22,1.25,1.25,0,0,0-1-1.08,2.89,2.89,0,0,0-2.05.39,7.93,7.93,0,0,0-2.3,2A14.65,14.65,0,0,0,330,215.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.29,164.45c-1.19,5.86-4.27,16.24-9.57,18.27,1.72,4.16,4.16,9.15,10.51,12.06s7.06-2,6.33-5c-5.44-4-3.41-8.38-.61-12.15Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,169.81l3.94,7.77a18.26,18.26,0,0,0-1.76,2.78c-2.17-1.3-4.29-5.16-3.53-7.68A8.83,8.83,0,0,1,341,169.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.28,164.67c6.27.46,11.82-15.18,2.67-17-6.17-1.23-6.11,2.46-6.76,6.5S350.31,164.38,354.28,164.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,156.75c-1.61,7.8-2.95,12.28-.15,17.28,4.22,7.51,14.64,6.57,18.56-.59,3.52-6.45,5.57-18.12-1.11-23.22A10.87,10.87,0,0,0,339,156.75Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.67,162.33c6.27.46,10.47-13.84,1.32-15.67-6.17-1.23-6.69,2.38-6.59,6.24C332.5,157,333.69,162,337.67,162.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.73,151.39c4.23,2.05,24.62,6.44,23.45-2.33s-12.06-12.84-12.06-12.84,6.34,6.95,1.11,5.28-6.73-2.89-13-4c0,0,6.16,5.11-1,3.67a17,17,0,0,0-12.16,1.94,12.09,12.09,0,0,1,5.28,11.27C333.86,162.09,342.73,151.39,342.73,151.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,162.7a7,7,0,0,0,2.72,4.55c1.92,1.41,3.67-.21,3.8-2.55.11-2.11-.75-5.39-3-5.86S333.7,160.44,334,162.7Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.92,249.81l-8.34,26.86,42.93,27c-7.41,12.36-45.06,24.66-45.06,24.66l6,12.18s52.43-4,63.06-27.18c10.23-22.26-32.7-52.72-32.7-52.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.49,285.42,302,280.73l9.22-13.4S311.48,278.07,309.49,285.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.49,285.42,302,280.73l9.22-13.4S311.48,278.07,309.49,285.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.53,256.74S285.91,314.32,271.62,333c-15.65,20.46-56.17,59-56.17,59l-12.07-8.4s35-38.58,48.19-59.93c15.05-24.32,38.64-79.6,38.64-79.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.71 393.28 202.5 383.4 205.45 379.15 221.53 389.92 216.71 393.28",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.95 342.18 292.76 327.67 297.45 325.35 305.73 341.45 299.95 342.18",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.07,162.06c-.17.62,0,1.22.43,1.33s.88-.3,1.05-.93,0-1.22-.44-1.33S350.24,161.44,350.07,162.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.13,164c-.17.63,0,1.22.43,1.33s.88-.3,1.05-.93,0-1.22-.43-1.33S357.3,163.36,357.13,164Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.8,163.68a23.26,23.26,0,0,0,1.53,6.16,3.74,3.74,0,0,1-3.14-.26Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.11,170.54a5.38,5.38,0,0,1-3-3,.2.2,0,0,1,.13-.24.2.2,0,0,1,.24.12,5.1,5.1,0,0,0,3.5,3,.18.18,0,0,1,.14.23.19.19,0,0,1-.24.13A5.63,5.63,0,0,1,350.11,170.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.51,159.19a.44.44,0,0,1-.15-.12.37.37,0,0,1,.07-.53,3.79,3.79,0,0,1,3.4-.71.39.39,0,0,1,.23.49.38.38,0,0,1-.48.23h0a3,3,0,0,0-2.69.59A.4.4,0,0,1,348.51,159.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.83,162.38a.37.37,0,0,1-.22-.28,3,3,0,0,0-1.62-2.22.38.38,0,1,1,.29-.7,3.76,3.76,0,0,1,2.07,2.78.37.37,0,0,1-.3.44A.33.33,0,0,1,360.83,162.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.05,402.07a9.22,9.22,0,0,1-.52-2.07.2.2,0,0,1,.09-.2.17.17,0,0,1,.2,0c.28.19,2.69,1.94,2.61,2.95a.66.66,0,0,1-.37.53,1.11,1.11,0,0,1-1.07,0A2.33,2.33,0,0,1,205.05,402.07ZM205,400.4c.25,1.38.69,2.33,1.19,2.59a.72.72,0,0,0,.72-.05c.14-.06.16-.14.16-.2C207.1,402.22,205.92,401.13,205,400.4Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.54,400a.2.2,0,0,1,.12-.26c.09,0,2.27-.8,3.32-.25a1,1,0,0,1,.52.65h0a.65.65,0,0,1-.23.77c-.75.52-3-.25-3.68-.83A.22.22,0,0,1,204.54,400Zm3.57.17a.66.66,0,0,0-.31-.33,4.37,4.37,0,0,0-2.65.15c.88.51,2.47.91,2.92.6,0,0,.13-.09.07-.33h0Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.12,342.44a.18.18,0,0,1,.08-.18.2.2,0,0,1,.22,0c.33.25,3.22,2.41,3.17,3.53a.6.6,0,0,1-.31.5h0a1,1,0,0,1-1,.09c-1.09-.44-1.83-2.64-2.17-3.91Zm3.09,3.25c-.08-.63-1.46-1.9-2.57-2.78.53,1.72,1.18,2.87,1.79,3.12a.69.69,0,0,0,.65-.06.21.21,0,0,0,.13-.2Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.12,342.44a0,0,0,0,1,0-.05.17.17,0,0,1,.12-.15c.08,0,2.12-.8,3.32-.25a1.36,1.36,0,0,1,.76.8h0c.18.49,0,.74-.16.87-.75.53-3.16-.42-4-1.1A.17.17,0,0,1,288.12,342.44Zm3.89.67a.59.59,0,0,0-.05-.19h0a1,1,0,0,0-.56-.59,4.39,4.39,0,0,0-2.68.15c1,.62,2.77,1.19,3.22.87A.22.22,0,0,0,292,343.11Zm.13-.26h0Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.05,192.32l-3.16-2.11c-1.09-.71-2.2-1.4-3.31-2.09-2.23-1.37-4.49-2.67-6.77-3.92s-4.59-2.39-6.92-3.41c-1.16-.53-2.33-1-3.5-1.45l-1.75-.62-.44-.15-.22-.08h0s-.07,0-.16-.07a8.74,8.74,0,0,0-2.51.15,27.67,27.67,0,0,0-3.4.85,75,75,0,0,0-7.23,2.72c-4.85,2.09-9.79,4.47-14.59,6.9l-3.39-5a107.76,107.76,0,0,1,13.83-10,69.7,69.7,0,0,1,7.83-4.11,38.08,38.08,0,0,1,4.49-1.62,18.06,18.06,0,0,1,5.68-.79,13.53,13.53,0,0,1,1.88.23l.47.11.28.07.55.14,2.2.57c1.44.43,2.89.86,4.27,1.39a77.09,77.09,0,0,1,8.13,3.44c2.63,1.26,5.18,2.66,7.67,4.14,1.23.76,2.46,1.53,3.67,2.33s2.37,1.6,3.67,2.57Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,183.83c-1.77-4.38-18.5-10.37-18.5-10.37l-5.41,14.12s5.85,3.87,10.7,6.77C323,199.9,330.46,192.45,327,183.83Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.7,186.93l-3.39,7.35-5.17-6.7s3.9-6.56,6.68-4Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.16 196.59 249.54 190.71 254.14 187.58 259.31 194.28 252.16 196.59",
    style: {
      fill: "#ff8b7b"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunningMan);
export default __webpack_public_path__ + "static/media/runningMan.e1dac2b0bbbc0cc2bfdef1bdfe9abedf.svg";
export { ForwardRef as ReactComponent };